import React from 'react';
import './Radio.css';

const Radio = ({ option, onChangeAction, name, test, isChecked }) => {


    return (

        test ?
            <>
                <input className='custom-radio' type="radio" id={option.id} name={name} onChange={(e) => { onChangeAction(e.target.id)}} checked={isChecked} />
                <label htmlFor={option.id}>{option.text}</label>
            </>
            :
            <>
                <input type="radio" className="custom-radio" name={name} id={option.id} onChange={(e) => { onChangeAction(e.target.id) }} checked={isChecked} />
                <label htmlFor={option.id}>
                    <div className='filterMenu__text'>{option.title}</div>

                </label>
            </>


    )
}
export default Radio
